module.exports = __webpack_public_path__ + "static/media/feeling-good.e093e71a.svg";